import {hideFeedbackButtonMixin} from './mixins/component-mixins';
import initCardActionComponents from '../components/card/card-action';

function initAdvertPreviewComponent(app) {
    app.component('advert-preview', {
        template: '#advert-preview',
        mixins: [hideFeedbackButtonMixin],
        props: {
            previewTitle: {
                type: String,
                default: null,
            },
        },
        methods: {
            shouldUpdateTitle() {
                return this.previewTitle;
            },
            updateTitle(newTitle) {
                document.title = newTitle;
            },
        },
        mounted() {
            if (this.shouldUpdateTitle()) {
                this.updateTitle(this.previewTitle);
            }
        },
    });

    initCardActionComponents(app);
}
export default initAdvertPreviewComponent;
